/** Reading the admin/MFA state out of a Firebase ID token. */

export const MFA_WINDOW_MS = 12 * 60 * 60 * 1000

export interface TokenClaims {
  admin?: unknown
  mfa?: unknown
  mfaAt?: unknown
}

export function isAdminClaim(claims: TokenClaims | null | undefined): boolean {
  return claims?.admin === true
}

/**
 * The second factor expires. Mirrors the same rule the Firestore rules apply,
 * so the UI never offers a button the database would refuse.
 */
export function isMfaValid(claims: TokenClaims | null | undefined, now: number = Date.now()): boolean {
  if (!isAdminClaim(claims)) return false
  if (claims?.mfa !== true) return false
  const at = claims?.mfaAt
  if (typeof at !== 'number' || !Number.isFinite(at)) return false
  if (at > now + 60_000) return false
  return now - at <= MFA_WINDOW_MS
}

export function mfaRemainingMs(claims: TokenClaims | null | undefined, now: number = Date.now()): number {
  if (!isMfaValid(claims, now)) return 0
  return Math.max(0, (claims!.mfaAt as number) + MFA_WINDOW_MS - now)
}

export function formatRemaining(ms: number): string {
  if (ms <= 0) return 'expired'
  const mins = Math.round(ms / 60_000)
  if (mins < 60) return `${mins} min`
  const hours = Math.floor(mins / 60)
  const rest = mins % 60
  return rest ? `${hours}h ${rest}m` : `${hours}h`
}
